import axios, { extractError } from '@atheneum/api'
import { extendObservable } from 'mobx'

class UploadStore {
  constructor (growlStore) {
    extendObservable(this, {
      error: null,
      loading: false,
      growlStore: growlStore
    })
  }

  upload = ({ file, url, onOk, onError }) => {
    this.loading = true

    const formData = new FormData()
    formData.append('file', file)
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }

    return axios
      .post(url, formData, config)
      .then(res => {
        this.loading = false
        if (onOk) return onOk(res)
      })
      .catch(err => {
        this.loading = false
        this.error = extractError(err)

        const message = this.error.message || 'Unknown error occured!'
        this.growlStore.addNotification({
          title: 'There was an error!',
          message: message,
          type: 'error',
          autoClose: true
        })

        if (onError) onError()
      })
  }
}

export default UploadStore
